import * as React from 'react';

export interface ReturnbuttonProps {
	router: any;
}

export const ReturnButton: React.SFC<ReturnbuttonProps> = (props) => {
	return(
		<div className="am_bottomleft">
			<button type="button" onClick={props.router.history.goBack}>
				<img width="55px" height="55px" src="/images/GreenReturnButton.png"></img>
			</button>
			<strong> Palaa etusivulle</strong>
		</div>
	);
};



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Common/returnbutton.tsx